import { Routes, RouterModule } from '@angular/router';
import { SuccessComponent } from './shared/success/success.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    pathMatch:'full'
  },
  {
    path: 'clearance-login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'clearance-login/:id',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'clearance-login/:id/:params',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'ceased-account',
    loadChildren: () => import('./ceased-account/ceased-account.module').then(m => m.CeasedAccountModule)
  },
  {
    path: 'ceased-account/:id',
    loadChildren: () => import('./ceased-account/ceased-account.module').then(m => m.CeasedAccountModule)
  },
  {
    path: 'ceased-account/:id/:params',
    loadChildren: () => import('./ceased-account/ceased-account.module').then(m => m.CeasedAccountModule)
  },
  // {
  //   path: 'create-request',
  //   loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  // },
  // {
  //   path: 'create-request/:id',
  //   loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  // },
  // {
  //   path: 'create-request/:id/:params',
  //   loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  // },
  
  // {
  //   path: 'create-request/step1',
  //   loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  // },
  // {
  //   path: 'create-request/step2',
  //   loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  // },
  
  // {
  //   path: 'create-request/personalInfo',
  //   loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  // },
  // {
  //   path: 'create-request/requestDetail',
  //   loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  // },
  
  // {
  //   path: 'track-request',
  //   loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  // },
  // {
  //   path: 'track-request/:id',
  //   loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  // },
  
  // {
  //   path: 'track-request/:id/:params',
  //   loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  // },
  // {
  //   path: 'track-request/detail',
  //   loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  // },
  // {
  //   path: 'track-request/search',
  //   loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  // },
  // {
  //   path: 'track-request/payment',
  //   loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  // },
  // {
  //   path: 'approve-quotation-letter',
  //   loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  // },
  // {
  //   path: 'approve-quotation-letter/:id',
  //   loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  // },
  
  // {
  //   path: 'approve-quotation-letter/:id/:params',
  //   loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  // },
  // {
  //   path: 'approve-quotation-letter/step1',
  //   loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  // },
  // {
  //   path: 'approve-quotation-letter/step2',
  //   loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  // },
  
  // {
  //   path: 'approve-quotation-letter/step3',
  //   loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  // },
  // {
  //   path: 'verification',
  //   component: VerificationComponent
  // },
  {
    path: 'success',
    component: SuccessComponent
  },
  {
    path: 'success/:params',
    component: SuccessComponent
  },
 
  {path: '**', redirectTo: '/clearance-login'}
];

export const AppRoutes = RouterModule.forRoot(routes);
